import { useGateValue } from '@statsig/react-bindings';

const useTrustedAdvisorRollout = () => {
  return useGateValue('trusted_advisor_rollout');
};

export default useTrustedAdvisorRollout;
